import React, { useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

// Shown once after a Dragino node is registered or its credentials are regenerated:
// the AT command sequence (with the certificates) to paste into the node over serial.
export default function DraginoSetupDialog({ setup, close, intl }) {
    const [copied, setCopied] = useState(false);
    if (!setup) return null;

    const t = (id, defaultMessage) => intl.formatMessage({ id, defaultMessage });

    const copy = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(setup.at_commands).then(() => setCopied(true)).catch(() => setCopied(false));
        }
    };

    const download = () => {
        const blob = new Blob([setup.at_commands], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `dragino_${setup.imei}_at_commands.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const buttonClass = 'k-button k-button-md k-button-solid k-button-solid-base k-rounded-md';

    return (
        <Dialog title={t('app.stations.dragino.setupTitle', 'Node setup commands')} onClose={close} width={760}>
            <div className='modal-wrap'>
                <p>{t('app.stations.dragino.setupIntro', 'Paste this sequence into the node over its serial console (9600 8N1, after the AT password) while the node is idle. The certificate lines are entered one by one; the last line of each certificate ends with "}".')}</p>
                <p style={{ color: '#b45309', fontWeight: 600 }}>{t('app.stations.dragino.warning', 'Shown only once: it contains the node\'s private key. Copy or download it now. If it is lost, use "Regenerate node credentials" on the station.')}</p>
                <div className='text-sm text-gray-500' style={{ marginBottom: '6px' }}>
                    {setup.model} · IMEI {setup.imei} · {setup.endpoint}
                </div>
                <textarea
                    readOnly
                    value={setup.at_commands}
                    onFocus={(e) => e.target.select()}
                    style={{ width: '100%', height: '320px', fontFamily: 'monospace', fontSize: '12px', whiteSpace: 'pre' }}
                />
            </div>
            <DialogActionsBar>
                <button className={buttonClass} onClick={copy}>
                    {copied ? t('app.stations.dragino.copied', 'Copied') : t('app.stations.dragino.copy', 'Copy')}
                </button>
                <button className={buttonClass} onClick={download}>{t('app.stations.dragino.download', 'Download .txt')}</button>
                <button className={buttonClass} onClick={close}>{t('app.stations.dragino.close', 'Close')}</button>
            </DialogActionsBar>
        </Dialog>
    );
}
